// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB0hs7LHBJ7HBPjKSaIk8U8dILeBw4zeQY",
  authDomain: "lyseis-tools-hub.firebaseapp.com",
  projectId: "lyseis-tools-hub",
  storageBucket: "lyseis-tools-hub.firebasestorage.app",
  messagingSenderId: "73286205424",
  appId: "1:73286205424:web:fd4e956db1d79089732735",
  measurementId: "G-CSM6MMC2BV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app, "us-central1"); // Cambia a la región que necesites
const storage = getStorage(app);

export { db, auth, storage, functions };